import { ageRestrictions } from 'shared/constants';
import { getComplianceConfig } from 'shared/core/helpers/compliance';

/**
 * Returns age restriction configuration for a given geo location.
 * @param {Object} geoInfo - Object containing country and region
 * @returns {Object} Object with medMinAge, recMinAge, requiresBirthdayEntry, and forceSessionStorage
 */
export function getAgeRestriction(geoInfo) {
  var _ageRestrictions$coun;
  var _ref = geoInfo || {},
    country = _ref.country,
    region = _ref.region;

  // For Canada, use the existing age restrictions constants
  // Canada already has birthday entry via the territory picker modal
  if (country === 'CA') {
    var provinceAge = ageRestrictions.CA[region] || ageRestrictions.CA["default"];
    return {
      medMinAge: provinceAge,
      recMinAge: provinceAge,
      requiresBirthdayEntry: true,
      // Canada always requires birthday entry
      forceSessionStorage: false
    };
  }

  // For US states, use compliance config which has detailed state-specific rules
  if (country === 'US') {
    var medMinAge = getComplianceConfig(region, 'medMinAge');
    var recMinAge = getComplianceConfig(region, 'recMinAge');
    var requiresBirthdayEntry = getComplianceConfig(region, 'requiresBirthdayEntry') || false;
    var forceSessionStorage = getComplianceConfig(region, 'forceSessionStorage') || false;
    return {
      medMinAge: medMinAge,
      recMinAge: recMinAge,
      requiresBirthdayEntry: requiresBirthdayEntry,
      forceSessionStorage: forceSessionStorage
    };
  }

  // For other countries, use default age restriction
  var defaultAge = ((_ageRestrictions$coun = ageRestrictions[country]) === null || _ageRestrictions$coun === void 0 ? void 0 : _ageRestrictions$coun["default"]) || ageRestrictions["default"];
  return {
    medMinAge: defaultAge,
    recMinAge: defaultAge,
    requiresBirthdayEntry: false,
    forceSessionStorage: false
  };
}